(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('doctor-specialty', {
            parent: 'entity',
            url: '/doctor-specialty?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.doctorSpecialty.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialties.html',
                    controller: 'DoctorSpecialtyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('doctorSpecialty');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('doctor-specialty-detail', {
            parent: 'entity',
            url: '/doctor-specialty/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.doctorSpecialty.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-detail.html',
                    controller: 'DoctorSpecialtyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('doctorSpecialty');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DoctorSpecialty', function($stateParams, DoctorSpecialty) {
                    return DoctorSpecialty.get({id : $stateParams.id});
                }]
            }
        })
        .state('doctor-specialty.new', {
            parent: 'doctor-specialty',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-dialog.html',
                    controller: 'DoctorSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('doctor-specialty', null, { reload: true });
                }, function() {
                    $state.go('doctor-specialty');
                });
            }]
        })
        .state('doctor-specialty.edit', {
            parent: 'doctor-specialty',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-dialog.html',
                    controller: 'DoctorSpecialtyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DoctorSpecialty', function(DoctorSpecialty) {
                            return DoctorSpecialty.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('doctor-specialty', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('doctor-specialty.delete', {
            parent: 'doctor-specialty',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/doctor-specialty/doctor-specialty-delete-dialog.html',
                    controller: 'DoctorSpecialtyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DoctorSpecialty', function(DoctorSpecialty) {
                            return DoctorSpecialty.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('doctor-specialty', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
